import React, { useState } from 'react';
import { getAudiogramPlatformsConfig } from 'blocks/DestinationPlatforms';
import ChooseDestinationModalContents from './ChooseDestinationModalContents';
import { AudiogramDestinationModalStep } from './types';
import VideoTypesContents from './VideoTypesModalContents';

export interface AudiogramDestinationModalContentsProps {}

const AudiogramDestinationModalContents: React.FC<AudiogramDestinationModalContentsProps> = () => {
  const [step, setStep] = useState<AudiogramDestinationModalStep>(
    'destination',
  );

  const audiogramPlatformsConfig = getAudiogramPlatformsConfig();

  if (step === 'destination') {
    return (
      <ChooseDestinationModalContents
        onDestinationClick={val => setStep(val)}
      />
    );
  }

  return (
    <VideoTypesContents
      destination={audiogramPlatformsConfig[step]}
      onBackClick={() => setStep('destination')}
    />
  );
};

export default AudiogramDestinationModalContents;
